import { render } from "./CheckboxesField.vue?vue&type=template&id=2f1e40ae"
import script from "./CheckboxesField.vue?vue&type=script&lang=js"
export * from "./CheckboxesField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__